<template>
  <div>
    <CustomModalComponent
      class="form-modal"
      :visible.sync="editVisible"
      :fullscreen="true"
      :show-close="false"
      :modal="false"
      v-loading="editProcessing"
    >
      <div id="edit-modal-header" class="modal-header">
        <div class="modal-header-layout flex grid-6 align-center">
          <h1 class="modal-title col-2">View / Edit a Partner</h1>
          <div class="modal-actions col-2">
            <el-button type="primary" @click="editOperation">
              Edit
            </el-button>
            <el-button type="default" @click="cancelOperation"
              >Cancel</el-button
            >
          </div>
        </div>
      </div>

      <el-form style="margin-top: 20px;">
        <div class="inline-form-group">
          <el-col :span="12">
            <el-input v-model="editForm.name" placeholder="Name">
              <template slot="prefix">Name</template>
            </el-input>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="11">
            <dads-select v-model="type" disabled placeholder="Type">
              <el-option
                v-for="(item, i) in typeOptions"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
              <template slot="prefix">Type</template>
            </dads-select>
          </el-col>
        </div>
        <dads-select v-model="tenantId" placeholder="Home Account" disabled>
          <el-option
            v-for="(item, i) in tenantsList"
            :key="i"
            :value="item.id"
            :label="item.name"
          />
          <template slot="prefix">Home Account</template>
        </dads-select>
        <el-checkbox v-model="editForm.enableCommission"
          >Enable Commission</el-checkbox
        >
        <el-input
          v-if="editForm.enableCommission"
          type="number"
          placeholder="Commission Rate"
          v-model.number="editForm.commissionRate"
        >
          <template slot="prefix">Commission Rate</template></el-input
        >
        <div class="inline-form-group">
          <el-col :span="12">
            <dads-select
              clearable
              filterable
              v-model="editForm.billDay"
              placeholder="Select desired bill day"
            >
              <template slot="prefix">Bill day</template>
              <el-option value="1" label="1st" />
              <el-option value="5" label="5th" />
              <el-option value="10" label="10th" />
              <el-option value="15" label="15th" />
              <el-option value="20" label="20th" />
            </dads-select>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="11">
            <dads-select
              clearable
              filterable
              v-model="editForm.omniaThemeId"
              placeholder="Select a theme"
            >
              <el-option
                v-for="(item, i) in omniaThemeOptions"
                :key="i"
                :value="item.id"
                :label="item.name"
              />
              <template slot="prefix">Theme</template>
            </dads-select>
          </el-col>
        </div>

        <div v-if="type === 'WHITELABEL'">
          <h2 class="form-section-header">10DLC Support Email</h2>

          <el-input
            name="autoAddressEdit"
            v-model="supportEmail10DLC"
            placeholder="Enter support email"
          >
            <template slot="prefix">10DLC Support email</template>
          </el-input>

          <h2 class="form-section-header">Port-Out Notifications Email</h2>

          <el-input
            name="autoAddressEdit"
            v-model="portOutNotificationsEmail"
            placeholder="Enter notifications email"
          >
            <template slot="prefix">Port-Out Notifications Email</template>
          </el-input>
        </div>

        <div v-if="type === 'WHITELABEL'">
          <h2 class="form-section-header">
            Partner Pricing
          </h2>
          <el-input
            v-for="(item, index) in partnerProducts"
            v-model="item.price"
            @change="(val) => cleanPartnerPrice(val, index)"
            :key="index"
            :placeholder="item.name"
          >
            <template slot="prefix">
              {{item.name}}
            </template>
          </el-input>
        </div>

      </el-form>
    </CustomModalComponent>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DadsSelect from "@/components/select";
import CustomModalComponent from "@/components/CustomModalComponent";

export default {
  name: "PartnersEditForm",

  props: {
    currentRecord: { required: true },
    editVisible: { required: true },
    clearFields: { required: true },
    editProcessing: { required: true },
    omniaThemeOptions: { required: true }
  },

  components: {
    DadsSelect,
    CustomModalComponent
  },

  data() {
    return {
      typeOptions: [
        {
          item: "Reseller",
          value: "RESELLER"
        },
        {
          item: "White Label",
          value: "WHITELABEL"
        }
      ],
      desiredBillDate: null,
      type: "",
      tenantId: null,
      partnerProducts: [],
      supportEmail10DLC: "",
      portOutNotificationsEmail: "",
      editForm: {
        name: "",
        enableCommission: false,
        commissionRate: null,
        billDay: null,
        omniaThemeId: null
      }
    };
  },

  computed: {
    ...mapGetters("tenants", { tenantList: "find" }),

    tenantsList() {
      return this.tenantList({
        query: {
          $sort: { name: 1 }
        }
      }).data;
    }
  },

  watch: {
    currentRecord(record) {
      if (record) {
        const {
          name,
          type,
          enableCommission,
          commissionRate,
          billDay,
          tenantId,
          omniaThemeId,
          partnerProducts,
          supportEmail10DLC,
          portOutNotificationsEmail
        } = record;
        this.tenantId = tenantId;
        this.editForm.name = name;
        this.type = type;
        this.editForm.enableCommission = !!enableCommission;
        this.editForm.commissionRate = commissionRate;
        this.editForm.omniaThemeId = omniaThemeId;
        this.partnerProducts = partnerProducts ? [...partnerProducts] : [];
        this.supportEmail10DLC = supportEmail10DLC;
        this.portOutNotificationsEmail = portOutNotificationsEmail;

        //get the bill date selection
        this.editForm.billDay = billDay ? billDay.toString() : '1';
      }
    },

    clearFields(val) {
      if (val) {
        this.clearForm();
      }
    }
  },

  methods: {
    clearForm() {
      this.desiredBillDate = null;
      this.type = null;
      this.tenantId = null;
      this.editForm = {
        name: "",
        enableCommission: false,
        commissionRate: null,
        billDay: null,
        omniaThemeId: null
      };
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    },

    editOperation() {
      const { enableCommission, commissionRate } = this.editForm;

      if(this.type === "WHITELABEL") {
        this.editForm.supportEmail10DLC = this.supportEmail10DLC;
        this.editForm.portOutNotificationsEmail = this.portOutNotificationsEmail;
      }

      const editBody = { ...this.editForm, partnerProducts: this.partnerProducts, tenantId: this.tenantId, type: this.type };
      editBody.enableCommission = enableCommission ? 1 : 0;
      editBody.commissionRate = enableCommission ? +commissionRate : null;

      this.$emit("editOperation", editBody);
    },

    cleanPartnerPrice(val, index) {
      this.partnerProducts[index].price = val.replace(/[^0-9.]|(\.(?=.*\.))/g, "");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.el-checkbox {
  max-width: 600px;
  margin: 0 auto;
}
</style>
